"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v6Upgrade = exports.v6Downgrade = void 0;
const v6Downgrade = (rule) => {
    const { ubCode, embUuid, trigger, dimensions, displaySettings, published, referrerTargets, urlTargets, cookieTarget, geoTargets, meta, id, event, version, parentVersion, } = rule;
    const frequency = rule.frequency;
    if (frequency.name === 'visitCount' && frequency.parameters[0].value === '1') {
        // @ts-expect-error Typescript doesn't understand that we're changing the type of frequency
        frequency.name = 'firstVisit';
    }
    return {
        ubCode,
        embUuid,
        meta,
        urlTargets,
        trigger,
        displaySettings,
        dimensions,
        published,
        frequency,
        referrerTargets,
        cookieTarget,
        geoTargets,
        id,
        event,
        version,
        parentVersion,
        schemaVersion: 5,
    };
};
exports.v6Downgrade = v6Downgrade;
const v6Upgrade = (rule) => {
    const { ubCode, embUuid, trigger, displaySettings, dimensions, published, referrerTargets, id, event, version, parentVersion, meta, cookieTarget, geoTargets, urlTargets, } = rule;
    // @ts-expect-error Typescript doesn't understand that we're changing the type of frequency
    const frequency = {
        name: rule.frequency.name === 'firstVisit' ? 'visitCount' : rule.frequency.name,
        parameters: rule.frequency.parameters,
    };
    return {
        ubCode,
        embUuid,
        trigger,
        displaySettings,
        dimensions,
        frequency,
        published,
        referrerTargets,
        id,
        event,
        version,
        parentVersion,
        meta,
        cookieTarget,
        geoTargets,
        urlTargets,
        schemaVersion: 6,
    };
};
exports.v6Upgrade = v6Upgrade;
//# sourceMappingURL=v06.js.map